
import Vue from "vue";
import AnuncioExternoService from '@/services/AnuncioExternoService';
import {Establecimiento} from "@/models/Establecimiento";
import RULES from "@/mixins/rules";
import CatastroService from "@/services/CatastroService";
import EstablecimientoService from "@/services/EstablecimientoService";
import AnuncioForm from "@/components/AnunciosExternos/Create/RequestFormExterno.vue";
import {Anuncio} from "@/models/Anuncio";
import {AnuncioExterno} from "@/models/AnuncioExterno";
import Direccion from "@/components/Beneficiarios/Direccion.vue";
import {VForm} from "@/types/formvalidate";
import {Domicilio} from "@/models/Domicilio";
import EventBus from "@/plugins/event-bus";
import CustomFile from "../Common/CustomFile.vue";

export default Vue.extend({
  name: "anuncios-externos",
  mixins: [RULES],
  components: {Direccion, AnuncioForm, CustomFile},
  directives: {},
  data: () => ({
    panel: [0],
    dialog: false,
    dialogPredial: false,
    dialogSendReview: false,
    dialogSolicitarAnuncio: false,
    dialogAutorizacionfile: false,
    disabled: true,
    disabledPredial: false,
    dialogFile: false,
    selectedItem: null as any,
    solicitudesAnuncios : [] as any[],
    selectedSolicitud : null as any,
    tipoPropiedades: [] as any[],
    fileInputArrendamiento: null,
    fileInputPropiedad: null,
    fileInputCedulaCatastral: null,
    hasAnuncios: false,
    isSolicitudCreada: false,
    formData: {
      ...new Establecimiento(),
      identificacion_predio: '',
    } as any,
    filters: {
      page: 1,
      clave_catastral_find: "",
      folio: "",
    },
    list: [],
    formAnuncios: [] as AnuncioExterno [],
    formDataAnuncio: new AnuncioExterno(),
    pagination: {
      from: 1,
      last_page: 1,
    },
    documento: null,
    documentoview: Document || null,
    dialogPDF: false,
  }),
  mounted() {
    this.getData();
  },
  computed: {
    formDir(): VForm {
      return this.$refs.formDireccion as VForm;
    },
  },
  watch: {
    "filters.page": function () {
      this.getData();
    },
    'formData.tipo_propiedad_id': function (newVal) {
      if (newVal === 1) {
        this.fileInputArrendamiento = null;
      } else if (newVal === 2) {
        this.fileInputPropiedad = null;
      }
    },

  },
  methods: {
    iniciarSolicitud(){
      this.$router.push({ name: 'solicitud-anuncio-externo', });
      //this.dialog = true;
    },
    async consultarCatastro(){
      /*let {data: {resultados: catastro}} = await CatastroService.searchByClaveCatastral(this.formData.clave_catastral);

      if(catastro != false){*/

        let { data } = await EstablecimientoService.getPagoPredial(this.formData.clave_catastral);

        if (data.data) {
          this.disabled = false;
          this.disabledPredial = true;
          this.$toast.success(data.message);
        } else {
          this.$toast.error(data.message)
          this.dialogPredial = true;
        }
      /*}else{
        this.$toast.error("La clave no ha sido encontrada en catastro")
      }*/
    },
    pagarPredialLinea(){
      window.open('https://predial.opb.gob.mx/predial', '_blank')
      //window.open(`https://predial.opb.gob.mx/predial?clave_catastral=${this.formData.clave_catastral}`, '_blank')
    },
    setDomicilio(domicilio: Domicilio) {
      this.formData.domicilio = Object.assign({}, domicilio);
    },
    setArrendamiento(e: any){
      const file = e.target ? e.target.files[0] : e;
      if (file && file.type !== 'application/pdf') {
        this.$toast.error('Para el contrato de arrendamiento solo se permiten archivos PDF');
      } else {
        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
          const file = fileReader.result;
          this.formData.documento_arrendamiento = file + "";
          this.updateFormData();
        });
        fileReader.readAsDataURL(e);
      }
    },
    setPropiedad(e: any){
      const file = e.target ? e.target.files[0] : e;
      if (file && file.type !== 'application/pdf') {
        this.$toast.error('Para el documento de propiedad solo se permiten archivos PDF');
      } else {
        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
          const file = fileReader.result;
          this.formData.documento_propiedad = file + "";
          this.updateFormData();
        });
        fileReader.readAsDataURL(e);
      }
    },
    setCedula(e: any){
      const file = e.target ? e.target.files[0] : e;
      if (file && file.type !== 'application/pdf') {
        this.$toast.error('Para la cedula catastral solo se permiten archivos PDF');
      } else {
        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
          const file = fileReader.result;
          this.formData.constancia_cedula_catastral = file + "";
          this.updateFormData();
        });
        fileReader.readAsDataURL(e);
      }
    },
    updateFormData() {
      if (this.formData.tipo_propiedad_id !== this.solicitudesAnuncios[0].tipo_propiedad_id) {
        this.formData.tipo_propiedad_id = this.solicitudesAnuncios[0].tipo_propiedad_id;
      }
    },
    updateIdentificacionPredio() {
      if (this.formData.identificacion_predio !== this.solicitudesAnuncios[0].identificacion_predio) {
        this.formData.identificacion_predio = this.solicitudesAnuncios[0].identificacion_predio;
      }
    },
    async showFileIndex(id: any){
      //@ts-ignore
      const response = await EstablecimientoService.descargarFormato(`documentacion/${id}`,{},'GET','Temp');

      let file = new Blob([response.data],{type: response.headers['content-type']});
      const url = window.URL.createObjectURL(file);

      //@ts-ignore
      this.documento = {
        //@ts-ignore
        title: this.label,
        url: url,
        mime: response.headers['content-type']
      }
      this.dialogFile = true;
    },
    getBase64(file: any) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
      },
    async handleFormSolicitudUpdateSubmit(SolicitudId: any) {
      EventBus.$emit("update-direccion");
      this.updateFormData();
      if (this.solicitudesAnuncios[0].documentos['documento_propiedad_archivo'].file) {
        let documento_propiedad_archivo = await this.getBase64(this.solicitudesAnuncios[0].documentos['documento_propiedad_archivo'].file);
        this.formData.documento_propiedad = documento_propiedad_archivo;
      }
      if (this.solicitudesAnuncios[0].documentos['documento_arrendamiento_archivo'].file) {
        let documento_arrendamiento_archivo = await this.getBase64(this.solicitudesAnuncios[0].documentos['documento_arrendamiento_archivo'].file);
        this.formData.documento_arrendamiento = documento_arrendamiento_archivo;
      }
      if (this.solicitudesAnuncios[0].documentos['constancia_cedula_catastral_archivo'].file) {
        let constancia_cedula_catastral_archivo = await this.getBase64(this.solicitudesAnuncios[0].documentos['constancia_cedula_catastral_archivo'].file);
        this.formData.constancia_cedula_catastral = constancia_cedula_catastral_archivo;
      }
      let response = await AnuncioExternoService.updateSolicitud(SolicitudId,this.formData).then((response) => {
        if (response.data.success) {
          this.hasAnuncios = false;
          this.$emit('formSubmitted', response.data);
          //console.log('datareturn',response.data.data);
          this.modalAnuncio(response.data.data);
          this.$toast.success('Solicitud actualizada exitosamente');
        }else{
          this.$toast.error(response.data.message);
        }
        //this.fileInputRenovacion = null;
        this.fileInputArrendamiento = null;
        this.fileInputPropiedad = null;
        this.fileInputCedulaCatastral = null;
      }).catch((error) => {
        this.hasAnuncios = false;
      });
    },
    async getData() {
      if (!this.filters.page) {
        this.filters.page = 1;
      }

      if (this.filters.clave_catastral_find || this.filters.folio) {
        this.filters.page = 1;
      }
      if (!this.filters.clave_catastral_find && !this.filters.folio) {
        this.filters.clave_catastral_find = "";
        this.filters.folio = "";
      }

      const { data } = await AnuncioExternoService.getByContribuyente(this.filters);

      this.pagination = {
        from: data.from,
        last_page: data.last_page
      }
      data.data.forEach((item: any) => {
        item.recibo_pago_extemporaneo_binary = null;
      })

      data.data.forEach((item: any) => {
        item.recibo_pago_du_binary = null;
      })
      this.list = data.data;
      //this.list = data;

      await EstablecimientoService.getTipoPropiedadesAnuncios().then((response) => {
        this.tipoPropiedades = response.data;
      });
    },
    async modalAnuncio(item: any) {
      this.selectedItem = item;
      this.solicitudesAnuncios = [];
      let { data } = await EstablecimientoService.getSolicitudesAnunciosById(item.id);
      this.solicitudesAnuncios = data;
      this.solicitudesAnuncios[0].documentos = [];
      this.solicitudesAnuncios[0].documentos['documento_propiedad_archivo'] = {
        code: 'documento_propiedad_archivo',
        file: '',
        binary: '',
        data: this.solicitudesAnuncios[0].documento_propiedad_archivo
      };
      this.solicitudesAnuncios[0].documentos['constancia_cedula_catastral_archivo'] = {
        code: 'constancia_cedula_catastral_archivo',
        file: '',
        binary: '',
        data: this.solicitudesAnuncios[0].constancia_cedula_catastral_archivo
      };
      this.solicitudesAnuncios[0].documentos['documento_arrendamiento_archivo'] = {
        code: 'documento_arrendamiento_archivo',
        file: '',
        binary: '',
        data: this.solicitudesAnuncios[0].documento_arrendamiento_archivo
      };
      this.hasAnuncios = true;
      if (this.solicitudesAnuncios[0].estatus_id === 1 || this.solicitudesAnuncios[0].estatus_id === 5) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    formatCustomDate(dateString: Date) {
      const date = new Date(dateString);
      const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
      const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

      const dayName = days[date.getDay()];
      const day = date.getDate();
      const monthName = months[date.getMonth()];
      const year = date.getFullYear();

      return `${dayName} ${day} de ${monthName} del ${year}`;
    },
    setColor(item: any, type: any) {
      switch (type) {
        case 1:
          if (item) {
            switch (item.id) {
              case 10:
                return "grey";
              case 4:
                return "green";
              case 5:
                return "red";
            }
          }
          break;
      }
      return "";
    },
    setStyle(item: any, type: any) {
      switch (type) {
        case 1:
          if (item) {
            switch (item.id) {
              case 10:
                return "color: white";
              case 4:
                return "color: white";
              case 5:
                return "color: white";
            }
          }
          break;
      }
      return "color: black";
    },
    setAnuncio(anuncio: AnuncioExterno, index: any) {
      this.formAnuncios[index] = Object.assign({}, anuncio);
    },
    async reloadAnuncios(){
      let { data } = await EstablecimientoService.getSolicitudesAnunciosById(this.selectedItem.id);
      //this.formAnuncios = data;
      this.solicitudesAnuncios = data;
    },
    incrementAnuncio(selectedItem: any) {
      this.selectedItem = selectedItem;
      this.reset();
      this.formAnuncios.push(new AnuncioExterno());
      this.dialogSolicitarAnuncio = true;
    },
    handleFormSubmitted() {
      this.dialogSolicitarAnuncio = false;
      this.reloadAnuncios();
    },
    async generarFmtAutorizacion(solicitud: any) {
      await AnuncioExternoService.generarFmtAutorizacion(
          `anuncioexterno/${solicitud.id}/generateformatoautorizacion`,
          'POST',
          'Temp'
      )
          .then((response) => {
            let file = new Blob([response.data],{type: response.headers['content-type']});
            const url = window.URL.createObjectURL(file);
            const tipoArchivo = 'archivo'
            //@ts-ignore
            this.documento = {
              title: tipoArchivo,
              url: url,
              mime: response.headers['content-type']
            }
            this.$toast.success('Formato de autorización generado.');
            this.dialogAutorizacionfile = true;
          }).catch((error) => {
            //this.$toast.error(error.response.data.message)
          })
    },
    async viewPrintedRequest(solicitud: any) {
      //console.log('solicitud a imprimir', solicitud);
      let url = `anuncioexterno/establecimiento/printRequest/${solicitud.id}`;
      await AnuncioExternoService.viewPrintedRequest(url, {}, 'GET', 'Temp')
          .then((response) => {
            let file = new Blob([response.data], { type: response.headers['content-type'] });
            const url = window.URL.createObjectURL(file);
            const tipoArchivo = 'Solicitud de Anuncio Publicitario';
            //@ts-ignore
            this.documento = {
              title: tipoArchivo,
              url: url,
              mime: response.headers['content-type']
            }
            this.dialogPDF = true;
          })
          .catch((error) => {

          })
    },
    openAlertReview(solicitud: any) {
      this.selectedSolicitud = solicitud;
      this.dialogSendReview = true;
    },
    async changeStatus(solicitud: any, estatus: any) {
      let data = {
        'solicitud': solicitud,
        'estatus_id': estatus
      }

      // this.disabled = true;
      await AnuncioExternoService.changeStatus(solicitud.id, data)
          .then((response) => {
            if (response.data.success) {
              this.$toast.success("Solicitud enviada exitosamente");
              this.hasAnuncios = false;
              this.cancelarEnvio();
            } else {
              this.$toast.error(response.data.message);
            }
          })
          .catch((error) => {
            ////this.$toast.error(error.response.data.message);
          })
    },
    cancelarEnvio() {
      this.selectedSolicitud = null;
      this.dialogSendReview = false;
    },
    reset() {
      this.formDataAnuncio = new AnuncioExterno();
    },
  },
});

